/**
 * Which chat thread is on screen, as a module-level store rather than a React context.
 *
 * The presence heartbeat is the only consumer, and it is a background effect that renders
 * nothing. Putting this in a context would re-render the whole tree every time a thread
 * opens or closes purely to feed it. ChatThread publishes; usePresenceHeartbeat listens.
 */

let activeChatKey: string | null = null;
const listeners = new Set<(key: string | null) => void>();

export function getActiveChatKey(): string | null {
  return activeChatKey;
}

export function setActiveChatKey(key: string | null): void {
  if (activeChatKey === key) return;
  activeChatKey = key;
  for (const listener of listeners) listener(key);
}

export function subscribeActiveChatKey(listener: (key: string | null) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
